"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContext = void 0;
var react_1 = require("react");
exports.ToastContext = react_1.createContext({
    show: function () { return ''; },
    dismiss: function () { return null; },
});
